import React from 'react'
import OpinarySelect from '../Controls/OpinarySelect'

export const Dropdown = ({
  onChange,
  disabled = false,
  className,
  colorClass,
  options,
  value,
  name,
}) => (
  <OpinarySelect
    colorClass={colorClass}
    disabled={disabled}
    onChange={onChange}
    options={options}
    className="w-50 h2 bb b--moon-gray ml3 mr3"
    name={name}
    value={value}
  />
)

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/PollCopy/Dropdown.js